import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from 'components/modals';

const EmployeeReminderModal = ({isOpen, onCancel}) => {
  return (
    <Modal isOpen={isOpen} onHide={onCancel} size='md' title='performance.Check-In reminder to employees'>
      <div className='border px3 py2 bg-haze rounded'>
        <div className='h4 py1'>
          <FormattedMessage id='performance.Hi (Employee Name),'/></div>
        <div className='h4 py1'>
          <FormattedMessage id='performance.It has been a while since you and (Leader Name) have completed a Check-In. Complete a quick Check-In now to stay up-to-date.'/>
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeReminderModal;
